// src/layouts/Pages/PageHeader/CardHeaderColumns/items/companyName.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { ShopOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';

// *******************************************************************************
// ITEM FUNCTION
// *******************************************************************************
export const companyNameItem = record => {
  const companyName = record?.fullName;

  return {
    key: 'companyName',
    icon: <ShopOutlined />,
    label: companyName,
    tooltipText: translateX('company_name'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export default companyNameItem;
